export default "__VITE_PUBLIC_ASSET__708e2f7a__"